module.exports = __webpack_public_path__ + "static/media/document-structure.79d18447.svg";